// Action Types
export const FETCH_BUSINESS_CASE_REQUEST = "FETCH_BUSINESS_CASE_REQUEST";
export const FETCH_BUSINESS_CASE_SUCCESS = "FETCH_BUSINESS_CASE_SUCCESS";
export const FETCH_BUSINESS_CASE_FAILURE = "FETCH_BUSINESS_CASE_FAILURE";

// Action Creators
export const fetchBusinessCaseRequest = ({opportunityId}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_BUSINESS_CASE_REQUEST,
      payload: {opportunityId},
    });
  };
};

export const fetchBusinessCaseSuccess = (data) => ({
  type: FETCH_BUSINESS_CASE_SUCCESS,
  payload: data,
});

export const fetchBusinessCaseFailure = (error) => ({
  type: FETCH_BUSINESS_CASE_FAILURE,
  payload: error,
});